/*
 * @Author: cn1994
 * @Date: 2023-07-26 14:47:30
 * @LastEditors: cn1994
 * @LastEditTime: 2025-03-28 17:42:20
 * @Description: file content
 */
// 教育请求地址
export const ossDomains = {
  preossm: {
    SCRMBaseUrl: 'https://xs.51tyty.com/scrm/index.php/',
    DCPBaseUrl: 'https://xs.51tyty.com/scrm/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wxtest.51tyty.com',
    QpBaseUrl: 'https://xsphp.51tyty.com/',
    OssBaseUrl: 'https://preoss.51tyty.com',
    QWBaseUrl: 'https://xs.51tyty.com/scrm/index.php', // 请求企培企业微信jssdk
    BusinessUrl: 'https://prebusiness.51tyty.com'
  }, // xs环境
  stage2ossm: {
    SCRMBaseUrl: 'https://vs2.51tyty.com/scrm/index.php/',
    DCPBaseUrl: 'https://vs2.51tyty.com/scrm/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wxtest.51tyty.com',
    QpBaseUrlN: 'https://vs2php-v8.51tyty.com/',
    QpBaseUrl: 'https://vs2php.51tyty.com/',
    OssBaseUrl: 'https://oss.51tyty.com',
    QWBaseUrl: 'https://vs2.51tyty.com/scrm/index.php',
    BusinessUrl: 'https://stage2business.51tyty.com'
  }, // vs2环境
  stage4ossm: {
    SCRMBaseUrl: 'https://vs2.51tyty.com/scrm/index.php/',
    DCPBaseUrl: 'https://vs2.51tyty.com/scrm/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wxtest.51tyty.com',
    QpBaseUrlN: 'https://vs2php-v8.51tyty.com/',
    QpBaseUrl: 'https://vs2php.51tyty.com/',
    OssBaseUrl: 'https://oss.51tyty.com',
    QWBaseUrl: 'https://vs2.51tyty.com/scrm/index.php',
    BusinessUrl: 'https://stage2business.51tyty.com'
  }, // vs4环境
  stage9ossm: {
    SCRMBaseUrl: 'https://stage9corptrainm.51tyty.com/',
    DCPBaseUrl: 'https://stage9corptrainm.51tyty.com/api/Api/api/',
    XCXBaseUrl: 'https://wxtest.51tyty.com',
    QpBaseUrl: 'https://vs9php.51tyty.com/',
    OssBaseUrl: 'https://stage9oss.51tyty.com',
    QWBaseUrl: 'https://stage9corptrainm.51tyty.com',
    BusinessUrl: 'https://stage9oss.51tyty.com'
  }, // vs9环境
  buwebgc: {
    SCRMBaseUrl: 'https://scrmgc.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrmgc.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wxtest.51tyty.com',
    QpBaseUrl: 'https://xt1.qipeiai.com/',
    OssBaseUrl: 'https://buservergc.51tyty.com',
    BusinessUrl: 'https://business.lingshi.com'
  }, // 预发布环境
  buweb: {
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://schoolapi.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  }, // 生产环境(临时)
  wxbgc: {  //医疗gc
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://wxbservergc.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  },
  wxb: {
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://schoolapi.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  }, // 生产环境(正式)
  kyb: {//看牙吧
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://schoolapi.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  }, // 生产环境(正式)
  yml: {//牙美力
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://schoolapi.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  },
  school: {
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://schoolapi.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  }, // 生产环境(正式)
  qipeigc: {
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://buservergc.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  }, // 生产环境(正式)
  qipei: {
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://schoolapi.lingshi.com',
    QWBaseUrl: 'https://corptrainm.lingshi.com/index.php',
    BusinessUrl: 'https://business.lingshi.com'
  }, // 生产环境(正式)
  mxschool: {
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://schoolapi.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  }, // 生产环境(正式)
  ldschool: {
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://schoolapi.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  }, // 生产环境(正式)
  usschool: {
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://schoolapi.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  }, // 生产环境(正式)
  hkschool: {
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://schoolapi.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  },
  account: {
    SCRMBaseUrl: 'https://scrm.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrm.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wechat.51tyty.com',
    QpBaseUrl: 'https://xt.qipeiai.com/',
    OssBaseUrl: 'https://schoolapi.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  },
  ylxsmanagement: {
    SCRMBaseUrl: 'https://xs.51tyty.com/scrm/index.php/',
    DCPBaseUrl: 'https://xs.51tyty.com/scrm/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wxtest.51tyty.com',
    QpBaseUrl: 'https://xsphp.51tyty.com/',
    OssBaseUrl: 'https://ylxs.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  },
  ylvsmanagement: {
    SCRMBaseUrl: 'https://vs2.51tyty.com/scrm/index.php/',
    DCPBaseUrl: 'https://vs2.51tyty.com/scrm/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wxtest.51tyty.com',
    QpBaseUrl: 'https://vs2php.51tyty.com/',
    OssBaseUrl: 'https://ylvs.lingshi.com',
    BusinessUrl: 'https://business.lingshi.com'
  }, // vs2医疗环境
  schoolgc: {
    SCRMBaseUrl: 'https://scrmgc.51tyty.com/index.php/',
    DCPBaseUrl: 'https://scrmgc.51tyty.com/index.php/api/Api/api/',
    XCXBaseUrl: 'https://wxtest.51tyty.com',
    QpBaseUrl: 'https://xt1.qipeiai.com/',
    OssBaseUrl: 'https://buservergc.51tyty.com',
    BusinessUrl: 'https://business.lingshi.com'
  }, // 预发布环境
}
